import { HeaderBar } from "../components/header-bar";
import { FooterBar } from "../components/footer-bar";
import { ContentBox } from "../components/content-box";
import { Link } from "react-router-dom";

export const PageFees = () => {
  return (
    <>
      <HeaderBar />
      <ContentBox>
        <h2>Betalning av kvartalsavgiften</h2>

        <p>
          Samfällighetsavgiften är 4440 kr per kvartal + 630 kr per kvartal för
          kollektivt bredbandsavtal. Totalt alltså 5070 per kvartal. (För ett
          hushåll som inte omfattas av bredbandsavtalet är avgiften 4440 kr).
        </p>

        <p>
          Från och med kvartal 3 (2024) automatiseras hanteringen av
          samfällighetsavgiften och internetavgiften. Det innebär att:
        </p>

        <ul>
          <li>
            Faktura på samfällighetsavgift och internet skickas ut via mail
            inför varje betalningstillfälle.
          </li>
          <li>
            Betalning sker sedan via fakturan senast det datum som anges som
            sista betalningsdatum.
          </li>
          <li>
            Vid betalningen anges OCR-numret på fakturan. OCR-numret visar
            vilken fastighet betalningen avser.
          </li>
          <li>
            Om inte betalning kommit in till sista betalningsdatum kommer en
            påminnelse att mailas ut efter ett par dagar.
          </li>
          <li>
            Upprepade sena betalningar kan leda till extra förseningsavgift på
            500 kr
          </li>
          <li>
            Om det är någon som saknar mailkonto kommer vi att lämna faktura och
            eventuell påminnelse i brevlådan.
          </li>
        </ul>

        <p>
          OBS! Om du lagt in automatisk överföring av avgiften via din bank
          måste du stoppa dessa.
        </p>

        <p>
          Vid frågor, kontakta samfällighetens kassör,{" "}
          <Link to="mailto:kassor@torparangen.se">kassor@torparangen.se</Link>
        </p>
      </ContentBox>
      <FooterBar />
    </>
  );
};
